import { Shield } from 'lucide-react';
import { useSiteConfig } from '../../hooks/useSiteConfig';

// 备案查询官方入口：号可以配，链接不能配——这两处地址由工信部/网安侧固定，
// 后台给一个可编辑的 URL 只会变成挂马入口。
const ICP_QUERY_URL = 'https://beian.miit.gov.cn/';
const POLICE_QUERY_URL = 'https://beian.mps.gov.cn/';

/**
 * 页脚版权与备案信息（ICP / 公安备案），内容全部来自后台「系统设置 → 站点信息」。
 *
 * 备案号留空时整条链接不渲染：号码还没批下来就挂上去（尤其挂别人的号码）属于
 * 「冒用他人备案信息」，接入商核查和 App 上架审核都会直接判不通过。
 * 版权行同理：留空则退回「© 当前年份 站点名」，不编造一个与主体无关的公司名。
 */
export function SiteFiling() {
  const { siteName, copyright, icpNumber, policeNumber } = useSiteConfig();

  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:divide-x sm:divide-slate-400/40">
      <span className="sm:pr-4">{copyright || `© ${new Date().getFullYear()} ${siteName} 版权所有`}</span>
      {icpNumber && (
        <a
          href={ICP_QUERY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="opacity-70 hover:opacity-100 transition-opacity flex items-center gap-1 sm:px-4"
        >
          <Shield className="h-3 w-3" />
          {icpNumber}
        </a>
      )}
      {policeNumber && (
        <a
          href={POLICE_QUERY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="opacity-70 hover:opacity-100 transition-opacity flex items-center gap-1 sm:pl-4"
        >
          <img
            src="https://beian.mps.gov.cn/img/ghs.png"
            alt="公安备案"
            className="h-3 w-auto"
          />
          {policeNumber}
        </a>
      )}
    </div>
  );
}
